<palantir-dialog [title]="'TAB_MAINTENANCE_SERVICES.DIALOG.TITLE' | translate">
  <palantir-dialog-content class="p-0">
    <palantir-input class="mt-6 mx-6" [control]="searchControl" prefix="search-outline">
      <input type="text" [placeholder]="'TAB_MAINTENANCE_SERVICES.DIALOG.SEARCH' | translate" [formControl]="searchControl" />
    </palantir-input>

    @if (!servicesTabService.isLoading() && !services().length) {
      <palantir-text type="description" size="xs" class="mx-6 mt-2">
        {{ 'TAB_MAINTENANCE_SERVICES.DIALOG.EMPTY' | translate }}
      </palantir-text>
    }

    <ng-scrollbar class="w-full flex flex-col max-h-[300px]" [visibility]="'hover'" [autoHeightDisabled]="false">
      <div class="flex flex-col gap-2 p-6 pt-1">
        @if (servicesTabService.isLoading()) {
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
        } @else {
          @for (service of services(); track service.id) {
            <palantir-list-item [attr.aria-selected]="isSelected(service.id)" (click)="toggleItem(service)" style="cursor: pointer">
              <palantir-list-item-prefix>
                <palantir-icon name="settings-outline"></palantir-icon>
              </palantir-list-item-prefix>
              <palantir-list-item-content>
                <palantir-text type="title" [truncate]="true">{{ service.name }}</palantir-text>
              </palantir-list-item-content>
              <palantir-list-item-suffix>
                <input
                  type="checkbox"
                  class="accent-color-primary"
                  [checked]="isSelected(service.id)"
                  (click)="$event.stopPropagation(); toggleItem(service)"
                />
              </palantir-list-item-suffix>
            </palantir-list-item>
          }
        }
      </div>
    </ng-scrollbar>
  </palantir-dialog-content>

  <palantir-dialog-actions>
    <palantir-button theme="outline" (click)="close()">
      {{ 'TAB_MAINTENANCE_SERVICES.DIALOG.BUTTONS.CANCEL' | translate }}
    </palantir-button>
    <palantir-button (click)="save()" [disabled]="!selectedItems().length">
      {{ 'TAB_MAINTENANCE_SERVICES.DIALOG.BUTTONS.SAVE' | translate }}
    </palantir-button>
  </palantir-dialog-actions>
</palantir-dialog>
